import React, { ReactNode, useState } from 'react';


export function Tooltip({ children, content, side = 'top', className }: {
  children: ReactNode;
  content: ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState<{ x: number; y: number }>({ x: 0, y: 0 });

  function onMove(e: React.MouseEvent) {
    setCoords({ x: e.clientX, y: e.clientY });
  }

  return (
    <span
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onMouseMove={onMove}
      className={['relative inline-block', className].filter(Boolean).join(' ')}
    >
      {children}
      {open && content && (
        <span
          className="fixed z-[60] pointer-events-none bg-ink text-bg text-xs rounded-sm px-2 py-1.5 max-w-[320px] tracking-tight whitespace-pre-line"
          style={{
            left: Math.min(coords.x + 12, window.innerWidth - 340),
            top: side === 'bottom' ? coords.y + 18 : coords.y - 8,
            transform: side === 'top' ? 'translateY(-100%)' : undefined,
          }}
        >
          {content}
        </span>
      )}
    </span>
  );
}
